import React from "react"


const Layout = ({ children, props }) => {


  return (
        <main>{children}</main>
  )
}


export default Layout
